import { useContext } from "react";
import { CurrentUserContext } from "@sprout/context/dist/currentUser";
function useCurrentUser() {
    return useContext(CurrentUserContext);
}
export default useCurrentUser;
